import { StatusEnum } from "../book/data-types"

export type Profile = {
    first_name: string
    last_name: string
    bio: string | null
    picture: string | null
    public_id: string
    registered: string
    followed_by_me?: boolean
    blocked_by_me?: boolean
    clubs: ProfileClubs
    badge?: {
        id: string
        image: string
    }
    stats: ProfileStats
}

export type ProfileStats = {
    messages: number
    books_added: number
    pages_read: number
    following: number
    followers: number
}

export type ProfileClubs = {
    last_joined: ProfileClub[]
    last_commented: ProfileClub[]
}

export type ProfileClub = {
    id: number
    status_id: StatusEnum
    title: string
    image: string | null
    isbn13: string
    language: string
}

export enum LibraryImportStatus {
    pending = "pending",
    success = "success",
    partial = "partial",
    error = "error",
}

export type LibraryImportBookResult = {
    success: boolean
    external_id: string | null
    error: string | null
    book_id: string | null
    status_id: string | null
}

export type LibraryImport = {
    id: number
    who_initiated_id: number
    source: string

    status: LibraryImportStatus
    errors: { [key: string]: string | LibraryImportBookResult }

    creation_date: string
}